import $http from './http'
import config from './config'

export default {
  name: 'insurancepolicy',
  getUrl(url) {
    return config.getUrl(this.name, url);
  },
  //下单保险匹配
  getInsuranceMatching(data) {
    return $http.post(this.getUrl(`/PolicyThrow/InsuranceMatching`), data);
  },
  getProductInfo(data){
    return $http.post(this.getUrl('/PolicyInfo/productInfo'),data,{failTips:false});
  },
}



// WEBPACK FOOTER //
// ./src/apis/insurancePolicyApis.js